import React from 'react';
import { Drawer, ErrorHandler, FileViewer } from '@common/components';
import { useQuery } from '@common/hooks';
import { DocumentByIdQuery } from '@common/graphql';

type Props = {
  open: boolean;
  onClose: () => void;
  blobId?: string;
};

export const DocumentPreviewDrawer = ({ open, onClose, blobId }: Props) => {
  const { loading, error, data } = useQuery(DocumentByIdQuery, {
    variables: { id: blobId || '' },
    skip: !blobId,
  });

  if (error) {
    return (
      <ErrorHandler
        error={error}
        log="DocumentPreviewDrawer"
        messageType="contextual"
      />
    );
  }

  const document = data?.documentById;
  const source = document
    ? [
        {
          id: document?.id,
          name: document?.filename,
          url: document?.downloadUrl,
          uploadedAt: document?.createdAt,
          contentType: document?.contentType,
        },
      ]
    : [];

  return (
    <Drawer
      open={open}
      onClose={onClose}
      loading={loading}
      size="lg"
      title="Document"
      className="document-preview-drawer"
    >
      <FileViewer source={source} />
    </Drawer>
  );
};
